import type { FC } from "react";

const searchInputStyle = `
[type="search"]::-webkit-search-cancel-button,
[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}

/* Work around for Tailwind + React Aria focus selector being broken on Autocomplete. */
[type="search"]:focus {
  box-shadow: none;
}
`;

/**
 * Strips Chrome's default clear button and focus ring from a React Aria
 * `SearchField` input. Render inside the element that wraps the field.
 */
export const SearchInputStyle: FC = () => (
  // oxlint-disable-next-line react/no-unknown-property
  <style scoped>{searchInputStyle}</style>
);
